import { Button, Collapse, GridLegacy as Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useState,useEffect } from "react";
import { FormatPrice, MotivosIngreso } from "../../../utils/constants";
import { Delete } from "@mui/icons-material";




export const SubtableIngresos = ({
    sub_items=[],
    isVisble=null,
    onDeleteIngreso=()=>{},
    disabledActionOnConfirm = false
})=>{


    return <Collapse sx={{width:'100%'}} in={(sub_items.length > 0 && [null,undefined].includes(isVisble) ) || isVisble } unmountOnExit >
    
    <Grid container  sx={{background:"#b2b2b2"}} padding='5px'  >
        <Grid item sm={12} sx={12} md={12} >
                <Typography variant="h6" fontSize='16px' >
                    Listado de novedades
                </Typography>
        </Grid>
        <Grid item sm={12} sx={12} md={12} >
            <Table style={{width:'100%'}} >
                <TableHead>
                    <TableRow>
                        <TableCell>SUB-COD</TableCell>
                        <TableCell>ITEM</TableCell>
                        <TableCell>CANT. INGRESADA</TableCell>
                        <TableCell>CANT. EQUIVALENTE</TableCell>
                       <TableCell>VALOR UN</TableCell>
                        <TableCell>ESTADO</TableCell>
                        <TableCell></TableCell>
                    </TableRow>

                </TableHead>
                <TableBody>
               
                    {
                        sub_items.map(item=>  <TableRow key={item.cod} >
                            <TableCell>{item.cod}</TableCell>
                            <TableCell>{item.nombre_producto}</TableCell>
                            <TableCell>{item.cantidad_entrada}  {item.p_unidad_medida_eam}</TableCell>
                            <TableCell>{item.total_um_ingresado}  {item.cod_erp_unidad}</TableCell>
                            <TableCell>$ {FormatPrice(item.vlr_neto)} COP</TableCell>
                            <TableCell>{MotivosIngreso[item.motivo]}</TableCell>
                            <TableCell><Button disabled={disabledActionOnConfirm} onClick={e=>onDeleteIngreso(item.cod)} size="small" variant="contained" color="error" > <Delete /> </Button></TableCell>
                        </TableRow>)
                    }
                  

                
                </TableBody>
            </Table>

        </Grid>
        
    </Grid>
    

    </Collapse>

}